// extracted by mini-css-extract-plugin
module.exports = {"login-form__separator":"loginForm_login-form__separator__VZGZa","login-form__footer":"loginForm_login-form__footer__2wIIk"};